import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { FaSearch } from 'react-icons/fa'
import { calcHeight, calcWidth, perMeterCalc } from '../../utils'
import { frames } from './names'
import { InfoBox, InfoText, MagnifierLink, SampleFrame } from './theme'

const stopPropagation = cb => e => {
  e.stopPropagation()
  cb(e)
}

const Frame = ({ width, height, text = '', frame = 'noframe', perMeter, borderWidth = 0, preview = '', onZoom }) => {
  return (<Fragment>
      {preview !== '' && (
        <MagnifierLink onClick={stopPropagation(() => onZoom(preview))}>
          <FaSearch/>
        </MagnifierLink>
      )}

      <SampleFrame
        w={calcWidth(width, height)}
        h={calcHeight(width, height)}
        f={frame}
        b={perMeterCalc(borderWidth, 400)}
      />
      {text !== '' && (
        <InfoBox>
          <InfoText>{text}</InfoText>
        </InfoBox>
      )}
    </Fragment>
  )
}

Frame.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  text: PropTypes.string,
  frame: PropTypes.oneOf(frames).isRequired,
  perMeter: PropTypes.number.isRequired,
  borderWidth: PropTypes.number,
  preview: PropTypes.string,
}

export default Frame



// WEBPACK FOOTER //
// ./src/components/Frame/index.js